<ng-container *transloco="let t">
    <div class="card popover-wrapper mb-1 pb-25 shadow-sm" [ngClass]="{'edit-template' : editMode}">
    <div class="card-header px-1 pt-75 pb-0 d-flex justify-content-between align-items-center">
        <label class="mb-0" [ngClass]="{'text-danger': fieldData?.field_invalid === 1}">{{fieldData?.select_type_text}}</label>
        @if(canEdit && !hide_setting_option){
            <button type="button" class="btn toolbar-icon p-0" (click)="openSetting()">
                <i data-feather="sliders" class="feather-icon cursor-pointer" [size]="16"></i>
            </button>
        }
    </div>
    <div class="card-body popover-body px-1 p-0" [ngClass]="{'pointer-none' : (+fieldData?.selected_for_role_id !== role_id || (fieldData?.selected_for_role_id === '-1' || fieldData?.field_section === 'user_field' || (fieldData?.selected_for_role_id === '-1'))) }">
        @switch (fieldData?.field) {
            @case ("text-field") {
                @if(fieldData?.allow_multi_lines === 1){
                    <textarea
                        #multilineInput
                        class="form-control font-small-3 meta-data-multi-field"
                        [id]="fieldData?.select_type_text"
                        [attr.uuid]="fieldData?.uuid"
                        rows="2"
                        (input)="textUpdate($event, fieldData)"
                        [ngClass]="{'text-grey': (disabledRecipientField || shouldFieldDisabled)}"
                        (blur)="textUpdate($event, fieldData)"
                        [placeholder]="fieldData?.placeholder ?? fieldData?.select_type_text"
                        [disabled]="fieldData?.enable_calculation"
                    >{{fieldData.value}}</textarea>
                } @else {
                    <input #textInput type="text" class="form-control tags-input" [placeholder]="fieldData?.placeholder ?? ''" [value]="fieldData?.value" (keyup)="textUpdate($event, fieldData)" [disabled]="fieldData?.enable_calculation" (focus)="getSuggestions($event, fieldData)" [attr.uuid]="fieldData?.uuid"/>
                }
            }@case ("datepicker-field") {
                <input #dateInput type="text" mwlFlatpickr class="form-control tags-input docfield_datePicker"
                (change)="syncDatepickerfield($event, fieldData)"
                [altInput]="true"
                [altFormat]="(false | userTimeZoneFormat) | async"
                [value]="fieldData?.value"
                [convertModelValue]="true"
                [monthSelectorType]="flatpickrDefaultInterFace.monthSelectorType"
                [placeholder]="fieldData?.placeholder ?? fieldData?.select_type_text"
                [disabled]="fieldData?.enable_calculation"
                readonly="readonly"
                (flatpickrOpen)="onReadyDatepicker($event)"
                [disableMobile]="true"
            />
            }@case ("droplist-field") {
                <ng-select #droplistSelect class="tags-select" [placeholder]='field?.placeholder ?? t("Content droplist select option (Template/Document - section) - Select option")' [ngModel]="(fieldData['value'] || null)" (change)="syncDroplistField($event, fieldData)" [multiple]="fieldData?.multi_select === 1" [clearable]="false" [closeOnSelect]="fieldData?.multi_select !== 1">
                    <ng-option [value]="''">{{fieldData?.placeholder || t("Content droplist select option (Template/Document - section) - Select option")}}</ng-option>
                    @for (option of fieldData['options'] | flattenOptions; track option.id) {
                        @if (option.hide !== 1 && option.value) {
                            <ng-option [value]="option.value">
                                <span
                                    [ngClass]="{ 
                                                    'child-option': option.level === 1,
                                                    'grand-child-option': option.level === 2
                                                }"                                    
                                >
                                    {{ option.name }}
                                </span>
                            </ng-option>   
                        }
                    }
                </ng-select>
            }
        }
    </div>
    </div>
</ng-container>
